import { ClientConfig } from 'client/configuration';
import { injectScript } from 'client/utils/inject-script';

export class ActivEngageChat {
  constructor({ dealerWebSite, launchSource, vehicleData }) {
    this.createChatConfig(dealerWebSite, launchSource, vehicleData);
  }

  createChatConfig(dealerWebSite, launchSource, vehicleData = {}) {
    this.chatEnv = ClientConfig.get('activEngage').chatEnv;
    /* extract hostname and use it as accountId */
    const accountId = dealerWebSite.match(/(?:[\w-]+\.)+[\w-]+/)?.[0];
    this.config = {
      accountId,
      data: {
        leadSource: 'edmunds',
        launchSource,
        ...vehicleData,
      },
    };
  }

  /**
   * Appends Active Engage script to the body.
   */

  init() {
    document.body.setAttribute('chat-env', this.chatEnv);
    if (!window.ActivEngage) {
      injectScript(ClientConfig.get('activEngage').scriptUrl);
    }
  }

  startChat() {
    window.ActivEngage.launchChat(this.config);
  }
}
